import connectBlockActions from "containers/schedule/connect_block_actions";

import BaseAddShiftButton from "components/schedule/add_shift_button";
import BaseShiftButton from "components/schedule/shift_button";
import BaseUnavailButton from "components/schedule/unavail_button";

const AddShiftButton = connectBlockActions(BaseAddShiftButton);
const ShiftButton = connectBlockActions(BaseShiftButton);
const UnavailButton = connectBlockActions(BaseUnavailButton);

export { AddShiftButton, ShiftButton, UnavailButton };
